import createTypes from 'redux-create-action-types';

export const asyncActionTypeRequest = (baseAction) => `${baseAction}_REQUEST`;
export const asyncActionTypeSuccess = (baseAction) => `${baseAction}_SUCCESS`;
export const asyncActionTypeFailure = (baseAction) => `${baseAction}_FAILURE`;

export const DESKTOP_REVIEW_ACTION_PREFIX = 'DESKTOP_REVIEW_INVOICE';

export default createTypes(
  `${DESKTOP_REVIEW_ACTION_PREFIX}_LIST`,
  `${DESKTOP_REVIEW_ACTION_PREFIX}_GET_ONE`,
  `${DESKTOP_REVIEW_ACTION_PREFIX}_CHECKOUT`,
  `${DESKTOP_REVIEW_ACTION_PREFIX}_CHECKOUT_BANK_TRANSFER`,
  `${DESKTOP_REVIEW_ACTION_PREFIX}_DOWNLOAD_INVOICE`,
);
